import React, { useState } from 'react';
import {
  ChevronLeft,
  Plus,
  Search,
  Calendar,
  Edit2,
  Trash2,
  Image as ImageIcon,
  Bold,
  Italic,
  Underline,
  Link,
  List,
  ListOrdered,
  Type,
  X,
  ChevronDown,
  Printer,
  FileText,
  CheckCircle2,
  HelpCircle,
  Vote,
  FileCheck,
  ToggleLeft,
  ToggleRight,
} from 'lucide-react';

export interface SurveyQuestionOption {
  id: string;
  text: string;
  votes: number;
}

export interface SurveyQuestion {
  id: string;
  title: string;
  type: 'single' | 'multiple';
  options: SurveyQuestionOption[];
}

export interface UnitVoteRecord {
  unitNo: string;
  status: 'voted' | 'unvoted' | 'submitted_doc';
  ownerName?: string;
  voteWeight?: number;
  votedAt?: string;
  selectedOptionId?: string;
}

export interface SurveyItem {
  id: string;
  title: string;
  description: string;
  content: string;
  coverImage?: string;
  author: string;
  postedAt: string;
  closeDate: string;
  votedCount: number;
  totalEligible: number;
  isDraft: boolean;
  status: 'active' | 'closed' | 'cancelled';
  questions: SurveyQuestion[];
  unitRecords: UnitVoteRecord[];
}

const generateMockUnits = (total: number, votedCount: number): UnitVoteRecord[] => {
  const list: UnitVoteRecord[] = [];
  for (let i = 1; i <= total; i++) {
    const numStr = i.toString().padStart(2, '0');
    const unitNo = `1086/${numStr}`;
    let status: 'voted' | 'unvoted' | 'submitted_doc' = 'unvoted';
    if (i <= votedCount) {
      status = 'voted';
    } else if (i === 12 || i === 25) {
      status = 'submitted_doc';
    }
    list.push({
      unitNo,
      status,
      ownerName: `เจ้าของร่วมห้อง ${unitNo}`,
      voteWeight: 1,
      votedAt: status === 'voted' ? '08/11/2023 10:15' : undefined,
    });
  }
  return list;
};

const INITIAL_SURVEYS: SurveyItem[] = [
  {
    id: 'srv-1',
    title: '52',
    description: 'แบบสำรวจความพึงพอใจและการใช้งานส่วนกลาง',
    content: 'ขอเชิญเจ้าของร่วมร่วมทำแบบสำรวจความพึงพอใจการให้บริการของฝ่ายบริหารอาคารประจำปี 2567 เพื่อนำข้อคิดเห็นและข้อเสนอแนะไปปรับปรุงการทำงานต่อไป',
    author: 'Silverman support',
    postedAt: '15/03/2024 - 16:01 น.',
    closeDate: '15/03/2024',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'ความพึงพอใจต่อระบบรักษาความปลอดภัย',
        type: 'single',
        options: [
          { id: 'o1', text: 'พึงพอใจมาก', votes: 0 },
          { id: 'o2', text: 'ปานกลาง', votes: 0 },
          { id: 'o3', text: 'ควรปรับปรุง', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-2',
    title: 'test',
    description: 'ทดสอบระบบการลงคะแนนโหวต',
    content: 'ทดสอบการส่งแบบสอบถามออนไลน์สำหรับระบบบริหารจัดการนิติบุคคล',
    author: 'Silverman support',
    postedAt: '21/02/2024 - 10:56 น.',
    closeDate: '21/02/2024',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'คำถามทดสอบ',
        type: 'single',
        options: [
          { id: 'o1', text: 'เห็นด้วย', votes: 0 },
          { id: 'o2', text: 'ไม่เห็นด้วย', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-3',
    title: 'QA tester',
    description: 'การทดสอบประสิทธิภาพการทำงาน',
    content: 'ทดสอบ',
    author: 'Silverman support',
    postedAt: '08/11/2023 - 09:56 น.',
    closeDate: '08/11/2023',
    votedCount: 1,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'ทดสอบ',
        type: 'single',
        options: [
          { id: 'o1', text: 'ทดสอบ1', votes: 1 },
          { id: 'o2', text: 'ทดสอบ2', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 1),
  },
  {
    id: 'srv-4',
    title: 'บ้านใหม่ 2023',
    description: 'แบบสำรวจการจัดงานต้อนรับปีใหม่',
    content: 'ขอความคิดเห็นการจัดกิจกรรมสังสรรค์ส่งท้ายปีเก่าต้อนรับปีใหม่',
    author: 'Silverman support',
    postedAt: '18/10/2023 - 17:17 น.',
    closeDate: '18/10/2023',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'ท่านต้องการให้มีการจัดงานปีใหม่หรือไม่',
        type: 'single',
        options: [
          { id: 'o1', text: 'ต้องการให้จัดงาน', votes: 0 },
          { id: 'o2', text: 'ไม่ต้องการ', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-5',
    title: 'หดเห้าก',
    description: 'แบบสำรวจความคิดเห็นเรื่องการบริหารจัดการขยะ',
    content: 'ข้อเสนอแนะเรื่องจุดพักขยะส่วนกลาง',
    author: 'Silverman support',
    postedAt: '18/10/2023 - 17:13 น.',
    closeDate: '18/10/2023',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-6',
    title: 'ชอบสีอะไร',
    description: 'สำรวจโทนสีทาสีรั้วโครงการใหม่',
    content: 'เลือกโทนสีที่ต้องการสำหรับการปรับปรุงทาสีรั้วส่วนกลาง',
    author: 'Silverman support',
    postedAt: '18/10/2023 - 15:09 น.',
    closeDate: '18/10/2023',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'โทนสีรั้วที่ท่านชื่นชอบ',
        type: 'single',
        options: [
          { id: 'o1', text: 'สีขาวคลาสสิก', votes: 0 },
          { id: 'o2', text: 'สีเทาโมเดิร์น', votes: 0 },
          { id: 'o3', text: 'สีครีมอบอุ่น', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-7',
    title: 'ไก่กับไข่อะไรเกิดก่อน',
    description: 'โพลล์ความคิดเห็นทั่วไป',
    content: 'โพลล์สนุกๆ ประจำสัปดาห์',
    author: 'Silverman support',
    postedAt: '18/10/2023 - 13:42 น.',
    closeDate: '18/10/2023',
    votedCount: 1,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [
      {
        id: 'q1',
        title: 'ไก่กับไข่อะไรเกิดก่อนกัน?',
        type: 'single',
        options: [
          { id: 'o1', text: 'ไก่เกิดก่อน', votes: 1 },
          { id: 'o2', text: 'ไข่เกิดก่อน', votes: 0 },
        ],
      },
    ],
    unitRecords: generateMockUnits(117, 1),
  },
  {
    id: 'srv-8',
    title: 'ชอบแมวไหม',
    description: 'สำรวจการลงทะเบียนสัตว์เลี้ยง',
    content: 'สำรวจจำนวนบ้านที่เลี้ยงสัตว์เลี้ยงประเภทแมว',
    author: 'Silverman support',
    postedAt: '18/10/2023 - 13:23 น.',
    closeDate: '18/10/2023',
    votedCount: 0,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [],
    unitRecords: generateMockUnits(117, 0),
  },
  {
    id: 'srv-9',
    title: 'ไก่ +ไข่ = ?',
    description: 'ทดสอบโจทย์แบบสอบถาม',
    content: 'แบบสอบถามทดสอบ',
    author: 'Silverman support',
    postedAt: '07/09/2023 - 18:38 น.',
    closeDate: '07/09/2023',
    votedCount: 1,
    totalEligible: 117,
    isDraft: false,
    status: 'active',
    questions: [],
    unitRecords: generateMockUnits(117, 1),
  },
];

interface Props {
  onBackToMenu: () => void;
}

export const AdminSurveyManagementView: React.FC<Props> = ({ onBackToMenu }) => {
  const [surveyList, setSurveyList] = useState<SurveyItem[]>(INITIAL_SURVEYS);
  
  // Navigation / View modes
  // 'list' | 'create_edit' | 'survey_detail' | 'print_preview'
  const [viewMode, setViewMode] = useState<'list' | 'create_edit' | 'survey_detail' | 'print_preview'>('list');
  const [selectedSurvey, setSelectedSurvey] = useState<SurveyItem | null>(null);
  const [editingItem, setEditingItem] = useState<SurveyItem | null>(null);

  // Search & Filters in Survey List
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedIds, setSelectedIds] = useState<string[]>([]);
  const [batchMenuOpen, setBatchMenuOpen] = useState(false);

  // Survey Detail States (Image 2 & 3)
  const [detailTab, setDetailTab] = useState<'all' | 'voted' | 'unvoted' | 'submitted_doc'>('all');
  const [detailSearch, setDetailSearch] = useState('');
  const [selectedUnitIds, setSelectedUnitIds] = useState<string[]>([]);
  const [detailBatchMenuOpen, setDetailBatchMenuOpen] = useState(false);

  // Results Modal State (Image 4 & 5)
  const [showResultsModal, setShowResultsModal] = useState(false);
  const [filterDocSubmittedOnly, setFilterDocSubmittedOnly] = useState(false);

  // Print target unit (if printing specific unit form or general template)
  const [printUnit, setPrintUnit] = useState<UnitVoteRecord | null>(null);

  // Create/Edit Form states (Image 4 & 5 of previous turn)
  const [formTitle, setFormTitle] = useState('');
  const [formEndDate, setFormEndDate] = useState('2024-03-31');
  const [formCoverImage, setFormCoverImage] = useState<string | null>(null);
  const [formContent, setFormContent] = useState('');
  const [formQuestions, setFormQuestions] = useState<SurveyQuestion[]>([
    {
      id: 'q-1',
      title: 'ท่านเห็นชอบกับข้อเสนอนี้หรือไม่?',
      type: 'single',
      options: [
        { id: 'opt-1', text: 'เห็นชอบ', votes: 0 },
        { id: 'opt-2', text: 'ไม่เห็นชอบ', votes: 0 },
      ],
    },
  ]);

  // Filtered Surveys for List View
  const filteredSurveys = surveyList.filter((item) => {
    const matches =
      item.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.author.toLowerCase().includes(searchQuery.toLowerCase());
    return matches;
  });

  // Filtered Units for Survey Detail View
  const getFilteredUnits = () => {
    if (!selectedSurvey) return [];
    return selectedSurvey.unitRecords.filter((u) => {
      // Tab filter
      if (detailTab === 'voted' && u.status !== 'voted') return false;
      if (detailTab === 'unvoted' && u.status !== 'unvoted') return false;
      if (detailTab === 'submitted_doc' && u.status !== 'submitted_doc') return false;

      // Search filter
      if (detailSearch) {
        return u.unitNo.toLowerCase().includes(detailSearch.toLowerCase());
      }
      return true;
    });
  };

  // Handler: Click survey title to view details (Image 1 -> Image 2)
  const handleOpenSurveyDetail = (survey: SurveyItem) => {
    setSelectedSurvey(survey);
    setDetailTab('all');
    setDetailSearch('');
    setSelectedUnitIds([]);
    setShowResultsModal(false);
    setViewMode('survey_detail');
  };

  // Handler: Click "+ เพิ่มแบบสอบถาม"
  const handleOpenCreate = () => {
    setEditingItem(null);
    setFormTitle('');
    setFormEndDate('2024-03-31');
    setFormCoverImage(null);
    setFormContent('');
    setFormQuestions([
      {
        id: `q-${Date.now()}`,
        title: 'ทดสอบ',
        type: 'single',
        options: [
          { id: `opt-1`, text: 'ทดสอบ1', votes: 0 },
          { id: `opt-2`, text: 'ทดสอบ2', votes: 0 },
        ],
      },
    ]);
    setViewMode('create_edit');
  };

  // Handler: Click edit icon
  const handleOpenEdit = (item: SurveyItem, e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    setEditingItem(item);
    setFormTitle(item.title);
    setFormEndDate(item.closeDate || '2024-03-31');
    setFormCoverImage(item.coverImage || null);
    setFormContent(item.content || item.description);
    setFormQuestions(
      item.questions && item.questions.length > 0
        ? item.questions
        : [
            {
              id: `q-${Date.now()}`,
              title: item.title,
              type: 'single',
              options: [
                { id: `opt-1`, text: 'ตัวเลือก 1', votes: 0 },
                { id: `opt-2`, text: 'ตัวเลือก 2', votes: 0 },
              ],
            },
          ]
    );
    setViewMode('create_edit');
  };

  // Handler: Delete Survey
  const handleDeleteItem = (id: string, e?: React.MouseEvent) => {
    if (e) e.stopPropagation();
    if (confirm('คุณต้องการลบแบบสอบถามนี้ใช่หรือไม่?')) {
      setSurveyList((prev) => prev.filter((item) => item.id !== id));
      setSelectedIds((prev) => prev.filter((i) => i !== id));
      if (selectedSurvey?.id === id) {
        setViewMode('list');
        setSelectedSurvey(null);
      }
    }
  };

  // Batch delete in Survey list
  const handleBatchDelete = () => {
    if (selectedIds.length === 0) return;
    if (confirm(`คุณต้องการลบแบบสอบถามที่เลือกจำนวน ${selectedIds.length} รายการใช่หรือไม่?`)) {
      setSurveyList((prev) => prev.filter((item) => !selectedIds.includes(item.id)));
      setSelectedIds([]);
      setBatchMenuOpen(false);
    }
  };

  // Unit detail select all
  const handleSelectAllUnits = (e: React.ChangeEvent<HTMLInputElement>) => {
    const list = getFilteredUnits();
    if (e.target.checked) {
      setSelectedUnitIds(list.map((u) => u.unitNo));
    } else {
      setSelectedUnitIds([]);
    }
  };

  const handleToggleUnitSelect = (unitNo: string) => {
    setSelectedUnitIds((prev) =>
      prev.includes(unitNo) ? prev.filter((id) => id !== unitNo) : [...prev, unitNo]
    );
  };

  // Open Print Layout (Image 6)
  const handleOpenPrint = (unit?: UnitVoteRecord) => {
    setPrintUnit(unit || null);
    setShowResultsModal(false);
    setViewMode('print_preview');
  };

  // Save new/edited survey
  const handleSaveSurvey = (isDraftSave: boolean = false) => {
    if (!formTitle.trim()) {
      alert('กรุณากรอกหัวข้อแบบสอบถาม');
      return;
    }

    const now = new Date();
    const formattedDate = `${now.getDate().toString().padStart(2, '0')}/${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}/${now.getFullYear() + 543} - ${now
      .getHours()
      .toString()
      .padStart(2, '0')}:${now.getMinutes().toString().padStart(2, '0')} น.`;

    if (editingItem) {
      const updated: SurveyItem = {
        ...editingItem,
        title: formTitle,
        description: formTitle,
        content: formContent,
        coverImage: formCoverImage || undefined,
        closeDate: formEndDate,
        isDraft: isDraftSave,
        questions: formQuestions,
      };
      setSurveyList((prev) =>
        prev.map((item) => (item.id === editingItem.id ? updated : item))
      );
      if (selectedSurvey?.id === editingItem.id) {
        setSelectedSurvey(updated);
      }
    } else {
      const newItem: SurveyItem = {
        id: `srv-${Date.now()}`,
        title: formTitle,
        description: formTitle,
        content: formContent,
        coverImage: formCoverImage || undefined,
        author: 'Silverman support',
        postedAt: formattedDate,
        closeDate: formEndDate,
        votedCount: 0,
        totalEligible: 117,
        isDraft: isDraftSave,
        status: 'active',
        questions: formQuestions,
        unitRecords: generateMockUnits(117, 0),
      };
      setSurveyList((prev) => [newItem, ...prev]);
    }

    setViewMode('list');
    setEditingItem(null);
  };

  const getStatusLabel = (status: 'voted' | 'unvoted' | 'submitted_doc') => {
    switch (status) {
      case 'voted':
        return 'ลงคะแนนแล้ว';
      case 'submitted_doc':
        return 'ส่งเอกสารแล้ว';
      case 'unvoted':
      default:
        return 'ยังไม่ลงคะแนน';
    }
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 shadow-2xs min-h-[80vh] flex flex-col font-sans">
      {/* ========================================================================= */}
      {/* 1. PRINT PREVIEW VIEW (Exact match to Image 6) */}
      {/* ========================================================================= */}
      {viewMode === 'print_preview' && selectedSurvey && (
        <div className="p-6 space-y-6 bg-slate-100 min-h-screen flex flex-col items-center">
          {/* Top Bar with Print and Back */}
          <div className="w-full max-w-4xl flex items-center justify-between no-print">
            <button
              type="button"
              onClick={() => setViewMode('survey_detail')}
              className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-300 bg-white hover:bg-slate-50 text-xs font-semibold text-slate-700 cursor-pointer shadow-2xs"
            >
              <ChevronLeft className="w-4 h-4" /> กลับสู่หน้ารายละเอียด
            </button>

            {/* Blue PRINT Button matching Image 6 */}
            <button
              type="button"
              onClick={() => window.print()}
              className="px-8 py-2 bg-blue-900 hover:bg-blue-950 text-white rounded-md text-xs font-bold shadow-md cursor-pointer tracking-wide"
            >
              PRINT
            </button>
          </div>

          {/* Printable White A4 Sheet matching Image 6 */}
          <div className="w-full max-w-4xl bg-white border border-slate-300 p-12 rounded-sm shadow-lg text-slate-900 font-sans space-y-6 print:m-0 print:p-8 print:border-none print:shadow-none min-h-[1050px]">
            {/* Box Header matching Image 6: แบบสอบถาม : [title] */}
            <div className="border border-slate-800 p-3.5">
              <h2 className="text-base font-bold text-slate-900">
                แบบสอบถาม : {selectedSurvey.title}
              </h2>
            </div>

            {/* Form Metadata Fields matching Image 6 */}
            <div className="space-y-2 text-xs text-slate-800 leading-relaxed font-sans">
              <div className="flex items-baseline">
                <span className="shrink-0 font-medium">ชื่อเจ้าของกรรมสิทธิ์/Name House-Owner :</span>
                <span className="flex-1 border-b border-dotted border-slate-600 ml-2 h-4 px-2 font-mono">
                  {printUnit?.ownerName || ''}
                </span>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="flex items-baseline">
                  <span className="shrink-0 font-medium">บ้านเลขที่/Unit(House) No. :</span>
                  <span className="flex-1 border-b border-dotted border-slate-600 ml-2 h-4 px-2 font-mono font-bold">
                    {printUnit?.unitNo || ''}
                  </span>
                </div>
                <div className="flex items-baseline">
                  <span className="shrink-0 font-medium">อัตราส่วนค่าใช้จ่าย/คะแนนเสียง :</span>
                  <span className="flex-1 border-b border-dotted border-slate-600 ml-2 h-4 px-2 font-mono">
                    {printUnit?.voteWeight ? `${printUnit.voteWeight} เสียง` : ''}
                  </span>
                </div>
              </div>

              <div className="flex items-baseline">
                <span className="shrink-0 font-medium">
                  จำนวนอัตราส่วนกรรมสิทธิ์/Right to common assets :
                </span>
                <span className="flex-1 border-b border-dotted border-slate-600 ml-2 h-4 px-2"></span>
              </div>

              <div className="pt-2">
                <span className="font-bold block text-slate-900">รายละเอียด/description</span>
                <p className="text-xs text-slate-700 mt-1 whitespace-pre-line leading-normal">
                  {selectedSurvey.content || selectedSurvey.description || 'ทดสอบ'}
                </p>
              </div>
            </div>

            {/* Survey Questions List matching Image 6 */}
            <div className="pt-4 space-y-6">
              {selectedSurvey.questions.length === 0 ? (
                <div className="space-y-2 text-xs">
                  <span className="font-bold text-slate-900">1. {selectedSurvey.title}</span>
                  <div className="pl-4 space-y-1.5 text-slate-700">
                    <div className="flex items-center gap-2">
                      <div className="w-3.5 h-3.5 rounded-full border border-slate-400"></div>
                      <span>เห็นชอบ</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-3.5 h-3.5 rounded-full border border-slate-400"></div>
                      <span>ไม่เห็นชอบ</span>
                    </div>
                  </div>
                </div>
              ) : (
                selectedSurvey.questions.map((q, qIdx) => (
                  <div key={q.id} className="space-y-2 text-xs">
                    <span className="font-bold text-slate-900">
                      {qIdx + 1}. {q.title}
                    </span>
                    <div className="pl-4 space-y-2 text-slate-800">
                      {q.options.map((opt) => (
                        <div key={opt.id} className="flex items-center gap-2.5">
                          <div className="w-3.5 h-3.5 rounded-full border border-slate-500 shrink-0"></div>
                          <span>{opt.text}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>

            {/* Signature Area matching Image 6 (Right aligned) */}
            <div className="pt-24 flex justify-end">
              <div className="w-64 text-center space-y-2">
                <div className="border-b border-dotted border-slate-700 w-full h-4"></div>
                <span className="text-xs text-slate-700 font-medium block">
                  ลงชื่อ/Signed
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* 2. SURVEY UNIT VOTING DETAIL SCREEN (Exact match to Image 2 & 3) */}
      {/* ========================================================================= */}
      {viewMode === 'survey_detail' && selectedSurvey && (
        <div className="p-5 sm:p-6 space-y-5">
          {/* Header Row matching Image 2 & 3: (< QA tester, จำนวนการโหวต 1/117, [ดูผลแบบสอบถาม]) */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-100 pb-4">
            <div className="space-y-1">
              <div className="flex items-center gap-2.5">
                <button
                  type="button"
                  onClick={() => setViewMode('list')}
                  className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
                  title="กลับสู่หน้ารายการแบบสอบถาม"
                >
                  <ChevronLeft className="w-5 h-5" />
                </button>
                <h1 className="text-xl font-bold text-slate-900">{selectedSurvey.title}</h1>
              </div>
              <p className="text-xs text-slate-500 pl-10 font-mono">
                จำนวนการโหวต {selectedSurvey.votedCount}/{selectedSurvey.totalEligible}
              </p>
            </div>

            {/* Blue Button matching Image 2 & 3: [ 📄 ดูผลแบบสอบถาม ] */}
            <button
              type="button"
              onClick={() => setShowResultsModal(true)}
              className="px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold flex items-center gap-2 shadow-xs transition-colors cursor-pointer self-start sm:self-auto"
            >
              <FileText className="w-4 h-4" /> ดูผลแบบสอบถาม
            </button>
          </div>

          {/* Sub-Tabs matching Image 2 & 3: ทั้งหมด | ลงคะแนนแล้ว | ยังไม่ลงคะแนน | ส่งเอกสารแล้ว */}
          <div className="flex items-center gap-6 border-b border-slate-200 text-xs font-semibold text-slate-600">
            <button
              type="button"
              onClick={() => setDetailTab('all')}
              className={`pb-2.5 relative transition-colors cursor-pointer ${
                detailTab === 'all' ? 'text-blue-600 font-bold border-b-2 border-blue-600' : 'hover:text-slate-900'
              }`}
            >
              ทั้งหมด
            </button>
            <button
              type="button"
              onClick={() => setDetailTab('voted')}
              className={`pb-2.5 relative transition-colors cursor-pointer ${
                detailTab === 'voted' ? 'text-blue-600 font-bold border-b-2 border-blue-600' : 'hover:text-slate-900'
              }`}
            >
              ลงคะแนนแล้ว
            </button>
            <button
              type="button"
              onClick={() => setDetailTab('unvoted')}
              className={`pb-2.5 relative transition-colors cursor-pointer ${
                detailTab === 'unvoted' ? 'text-blue-600 font-bold border-b-2 border-blue-600' : 'hover:text-slate-900'
              }`}
            >
              ยังไม่ลงคะแนน
            </button>
            <button
              type="button"
              onClick={() => setDetailTab('submitted_doc')}
              className={`pb-2.5 relative transition-colors cursor-pointer ${
                detailTab === 'submitted_doc'
                  ? 'text-blue-600 font-bold border-b-2 border-blue-600'
                  : 'hover:text-slate-900'
              }`}
            >
              ส่งเอกสารแล้ว
            </button>
          </div>

          {/* Action Bar matching Image 2 & 3: จัดการหลายรายการ ▾, 🖨️ icon button, 🔍 Search input */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-1">
            <div className="flex items-center gap-2 w-full sm:w-auto">
              {/* Batch Action */}
              <div className="relative">
                <button
                  type="button"
                  onClick={() => setDetailBatchMenuOpen(!detailBatchMenuOpen)}
                  className="px-3.5 py-1.5 rounded-lg border border-slate-300 bg-white hover:bg-slate-50 text-xs font-medium text-slate-700 flex items-center gap-2 cursor-pointer shadow-2xs"
                >
                  <span>จัดการหลายรายการ</span>
                  <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
                </button>

                {detailBatchMenuOpen && (
                  <div className="absolute left-0 mt-1 w-48 bg-white border border-slate-200 rounded-xl shadow-lg p-1.5 z-20 space-y-1 text-xs">
                    <button
                      type="button"
                      onClick={() => {
                        alert(`พิมพ์แบบฟอร์มลงคะแนนสำหรับ ${selectedUnitIds.length} ห้องที่เลือก`);
                        setDetailBatchMenuOpen(false);
                      }}
                      disabled={selectedUnitIds.length === 0}
                      className={`w-full text-left px-3 py-1.5 rounded-lg font-medium flex items-center gap-2 ${
                        selectedUnitIds.length > 0
                          ? 'text-slate-700 hover:bg-slate-50 cursor-pointer'
                          : 'text-slate-300 cursor-not-allowed'
                      }`}
                    >
                      <Printer className="w-3.5 h-3.5" /> พิมพ์รายการที่เลือก ({selectedUnitIds.length})
                    </button>
                  </div>
                )}
              </div>

              {/* Print Button Icon matching Image 2 & 3 */}
              <button
                type="button"
                onClick={() => handleOpenPrint()}
                className="p-1.5 border border-slate-300 rounded-lg bg-white hover:bg-slate-50 text-slate-600 transition-colors cursor-pointer shadow-2xs"
                title="พิมพ์แบบสอบถามทั้งหมด"
              >
                <Printer className="w-4 h-4" />
              </button>
            </div>

            {/* Search box on right */}
            <div className="relative w-full sm:w-64">
              <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
              <input
                type="text"
                placeholder="ค้นหา"
                value={detailSearch}
                onChange={(e) => setDetailSearch(e.target.value)}
                className="w-full pl-8 pr-2.5 py-1.5 border border-slate-300 rounded-lg text-xs bg-white text-slate-700 focus:outline-none"
              />
            </div>
          </div>

          {/* Unit Records Table matching Image 2 & 3 */}
          <div className="border border-slate-200 rounded-xl overflow-hidden shadow-2xs">
            <table className="w-full text-left text-xs">
              <thead className="bg-slate-100/80 text-slate-600 font-semibold border-b border-slate-200">
                <tr>
                  <th className="p-3 w-10 text-center">
                    <input
                      type="checkbox"
                      onChange={handleSelectAllUnits}
                      checked={
                        getFilteredUnits().length > 0 &&
                        selectedUnitIds.length === getFilteredUnits().length
                      }
                      className="rounded text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="p-3 w-40">ห้อง</th>
                  <th className="p-3">สถานะ</th>
                  <th className="p-3 w-28 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {getFilteredUnits().length === 0 ? (
                  <tr>
                    <td colSpan={4} className="py-12 text-center text-slate-400">
                      ไม่พบข้อมูลห้องในหมวดหมู่นี้
                    </td>
                  </tr>
                ) : (
                  getFilteredUnits().map((unit) => {
                    const isSelected = selectedUnitIds.includes(unit.unitNo);
                    return (
                      <tr
                        key={unit.unitNo}
                        className={`hover:bg-slate-50 group transition-colors ${
                          isSelected ? 'bg-blue-50/30' : ''
                        }`}
                      >
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => handleToggleUnitSelect(unit.unitNo)}
                            className="rounded text-blue-600 focus:ring-blue-500"
                          />
                        </td>

                        <td className="p-3">
                          <span
                            onClick={() => handleOpenPrint(unit)}
                            className="font-mono text-sky-600 hover:text-sky-700 hover:underline cursor-pointer font-medium"
                          >
                            {unit.unitNo}
                          </span>
                        </td>

                        <td className="p-3 text-slate-600">
                          <span
                            className={`${
                              unit.status === 'voted'
                                ? 'text-emerald-600 font-semibold'
                                : unit.status === 'submitted_doc'
                                ? 'text-blue-600 font-semibold'
                                : 'text-slate-600'
                            }`}
                          >
                            {getStatusLabel(unit.status)}
                          </span>
                        </td>

                        <td className="p-3 text-right">
                          <div className="flex items-center justify-end gap-2 text-slate-400 opacity-0 group-hover:opacity-100 transition-opacity">
                            <button
                              type="button"
                              onClick={() => handleOpenPrint(unit)}
                              title="พิมพ์เอกสารของห้องนี้"
                              className="p-1 hover:text-slate-700 transition-colors cursor-pointer"
                            >
                              <Printer className="w-3.5 h-3.5" />
                            </button>
                            <button
                              type="button"
                              onClick={() => {
                                if (confirm(`คุณต้องการรีเซ็ตสถานะของห้อง ${unit.unitNo} ใช่หรือไม่?`)) {
                                  setSelectedSurvey((prev) =>
                                    prev
                                      ? {
                                          ...prev,
                                          unitRecords: prev.unitRecords.map((u) =>
                                            u.unitNo === unit.unitNo
                                              ? { ...u, status: 'unvoted' }
                                              : u
                                          ),
                                        }
                                      : prev
                                  );
                                }
                              }}
                              title="ลบ/รีเซ็ต"
                              className="p-1 hover:text-rose-600 transition-colors cursor-pointer"
                            >
                              <Trash2 className="w-3.5 h-3.5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between text-xs text-slate-500 pt-2">
            <span>รายการห้องทั้งหมด {getFilteredUnits().length} ห้อง</span>
          </div>

          {/* ========================================================================= */}
          {/* RESULTS MODAL (Exact match to Image 4 & 5) */}
          {/* ========================================================================= */}
          {showResultsModal && (
            <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-xs flex items-center justify-center p-4 z-50 animate-fade-in">
              <div className="bg-white rounded-2xl border border-slate-200 shadow-2xl max-w-2xl w-full overflow-hidden flex flex-col max-h-[90vh]">
                {/* Modal Header matching Image 4 & 5 */}
                <div className="p-4 border-b border-slate-100 flex items-center justify-between bg-slate-50/50">
                  {/* Left: 🖨️ พิมพ์ Button matching Image 4 & 5 */}
                  <button
                    type="button"
                    onClick={() => handleOpenPrint()}
                    className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg border border-slate-300 hover:bg-slate-100 text-xs font-semibold text-slate-700 transition-colors cursor-pointer shadow-2xs"
                  >
                    <Printer className="w-3.5 h-3.5" /> พิมพ์
                  </button>

                  {/* Right: Toggle "แสดงคะแนนเฉพาะผู้ส่งเอกสารแล้ว" & Close button */}
                  <div className="flex items-center gap-4">
                    <label className="flex items-center gap-2 text-xs text-slate-600 font-medium cursor-pointer">
                      <span>แสดงคะแนนเฉพาะผู้ส่งเอกสารแล้ว</span>
                      <button
                        type="button"
                        onClick={() => setFilterDocSubmittedOnly(!filterDocSubmittedOnly)}
                        className="text-slate-400 hover:text-blue-600 transition-colors"
                      >
                        {filterDocSubmittedOnly ? (
                          <ToggleRight className="w-7 h-7 text-blue-600" />
                        ) : (
                          <ToggleLeft className="w-7 h-7 text-slate-300" />
                        )}
                      </button>
                    </label>

                    <button
                      type="button"
                      onClick={() => setShowResultsModal(false)}
                      className="p-1 rounded-full text-slate-400 hover:bg-slate-200 hover:text-slate-700 transition-colors"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                </div>

                {/* Modal Body matching Image 4 & 5 */}
                <div className="p-6 overflow-y-auto space-y-6 text-slate-800">
                  <div className="space-y-1">
                    <h3 className="text-lg font-bold text-slate-900">{selectedSurvey.title}</h3>
                    <p className="text-xs text-slate-500 font-mono">
                      จำนวนผู้ลงคะแนน {selectedSurvey.votedCount}/{selectedSurvey.totalEligible}
                    </p>
                  </div>

                  {/* Questions & Voting Percentages matching Image 4 & 5 */}
                  <div className="space-y-6">
                    {selectedSurvey.questions.length === 0 ? (
                      <div className="space-y-3">
                        <h4 className="text-xs font-bold text-slate-800">1. {selectedSurvey.title}</h4>
                        <div className="space-y-2 pl-2">
                          <div className="flex items-center justify-between text-xs py-1 border-b border-slate-50">
                            <div className="flex items-center gap-2.5">
                              <div className="w-3.5 h-3.5 rounded-full border border-slate-300"></div>
                              <span>เห็นชอบ</span>
                            </div>
                            <span className="text-sky-600 font-medium font-mono text-[11px]">
                              คะแนน 100% ({selectedSurvey.votedCount} คน)
                            </span>
                          </div>
                          <div className="flex items-center justify-between text-xs py-1 border-b border-slate-50">
                            <div className="flex items-center gap-2.5">
                              <div className="w-3.5 h-3.5 rounded-full border border-slate-300"></div>
                              <span>ไม่เห็นชอบ</span>
                            </div>
                            <span className="text-sky-600 font-medium font-mono text-[11px]">
                              คะแนน 0% (0 คน)
                            </span>
                          </div>
                        </div>
                      </div>
                    ) : (
                      selectedSurvey.questions.map((q, qIdx) => {
                        const totalVotesInQ = q.options.reduce((acc, o) => acc + o.votes, 0);
                        return (
                          <div key={q.id} className="space-y-3">
                            <h4 className="text-xs font-bold text-slate-800">
                              {qIdx + 1}. {q.title}
                            </h4>

                            <div className="space-y-2 pl-2">
                              {q.options.map((opt) => {
                                const pct =
                                  totalVotesInQ > 0
                                    ? ((opt.votes / selectedSurvey.totalEligible) * 100).toFixed(2)
                                    : '0';
                                return (
                                  <div
                                    key={opt.id}
                                    className="flex items-center justify-between text-xs py-1.5 border-b border-slate-50"
                                  >
                                    <div className="flex items-center gap-2.5 text-slate-700">
                                      <div className="w-3.5 h-3.5 rounded-full border border-slate-300"></div>
                                      <span>{opt.text}</span>
                                    </div>
                                    <span className="text-sky-600 font-medium font-mono text-xs">
                                      คะแนน {pct}% ({opt.votes} คน)
                                    </span>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* ========================================================================= */}
      {/* 3. CREATE / EDIT SURVEY SCREEN */}
      {/* ========================================================================= */}
      {viewMode === 'create_edit' && (
        <div className="p-6 space-y-6">
          {/* Top Action Header */}
          <div className="flex items-center justify-between border-b border-slate-100 pb-4">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setViewMode('list')}
                className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-bold text-slate-900">
                {editingItem ? 'แก้ไขแบบสอบถาม' : 'เพิ่มแบบสอบถาม'}
              </h1>
            </div>

            {/* Top Right Buttons */}
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={() => setViewMode('list')}
                className="px-4 py-2 rounded-lg border border-slate-300 hover:bg-slate-50 text-slate-700 text-xs font-semibold transition-colors cursor-pointer"
              >
                ยกเลิก
              </button>
              <button
                type="button"
                onClick={() => handleSaveSurvey(true)}
                className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 hover:bg-blue-50 text-xs font-bold transition-colors cursor-pointer"
              >
                บันทึกแบบร่าง
              </button>
              <button
                type="button"
                onClick={() => handleSaveSurvey(false)}
                className="px-5 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-xs font-bold shadow-xs transition-colors cursor-pointer"
              >
                โพสต์ทันที
              </button>
            </div>
          </div>

          {/* Form Layout: 2 Columns */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start">
            {/* Left Column: Form Fields */}
            <div className="lg:col-span-7 space-y-5">
              <div className="border border-slate-200 rounded-xl p-5 bg-white space-y-4 shadow-2xs">
                {/* หัวข้อ */}
                <div className="space-y-1.5">
                  <label className="text-xs font-bold text-slate-800 block">หัวข้อ</label>
                  <input
                    type="text"
                    placeholder="เช่น QA tester หรือ แบบสำรวจความพึงพอใจ"
                    value={formTitle}
                    onChange={(e) => setFormTitle(e.target.value)}
                    className="w-full p-2.5 text-xs bg-white border border-slate-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-blue-500 text-slate-800"
                  />
                </div>

                {/* วันที่สิ้นสุดการโหวต */}
                <div className="space-y-1.5">
                  <label className="text-xs font-bold text-slate-800 block">
                    วันที่สิ้นสุดการโหวต
                  </label>
                  <div className="relative max-w-xs">
                    <input
                      type="date"
                      value={formEndDate}
                      onChange={(e) => setFormEndDate(e.target.value)}
                      className="w-full p-2 text-xs bg-white border border-slate-200 rounded-lg text-slate-800 focus:outline-none"
                    />
                  </div>
                </div>

                {/* ภาพหัวข้อเรื่อง */}
                <div className="space-y-1.5">
                  <label className="text-xs font-bold text-slate-800 block">
                    ภาพหัวข้อเรื่อง{' '}
                    <span className="text-[11px] font-normal text-rose-400">
                      * ไฟล์ภาพ jpg,png เท่านั้น ขนาดไม่เกิน 2000 x 2000 พิกเซล
                    </span>
                  </label>

                  {formCoverImage ? (
                    <div className="relative border border-slate-200 rounded-xl overflow-hidden group max-w-md">
                      <img
                        src={formCoverImage}
                        alt="Cover"
                        className="w-full h-44 object-cover"
                        referrerPolicy="no-referrer"
                      />
                      <button
                        type="button"
                        onClick={() => setFormCoverImage(null)}
                        className="absolute top-2 right-2 p-1.5 rounded-full bg-slate-900/70 text-white hover:bg-rose-600 transition-colors"
                      >
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                  ) : (
                    <div
                      onClick={() =>
                        setFormCoverImage(
                          'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=800&q=80'
                        )
                      }
                      className="border-2 border-dashed border-slate-200 hover:border-blue-400 rounded-xl p-8 flex flex-col items-center justify-center gap-2 cursor-pointer bg-slate-50/50 hover:bg-blue-50/20 transition-all text-slate-400 hover:text-blue-600"
                    >
                      <ImageIcon className="w-10 h-10 stroke-[1.2]" />
                      <span className="text-xs font-medium text-slate-600">คลิกเพื่อเลือกรูปภาพ</span>
                    </div>
                  )}
                </div>

                {/* เนื้อหา */}
                <div className="space-y-1.5">
                  <label className="text-xs font-bold text-slate-800 block">เนื้อหา</label>
                  <div className="border border-slate-200 rounded-xl overflow-hidden bg-white">
                    <div className="p-2 border-b border-slate-200 bg-slate-50/80 flex items-center gap-2 flex-wrap text-slate-600 text-xs">
                      <div className="flex items-center gap-1 border-r border-slate-200 pr-2">
                        <span className="text-[11px] font-medium">Normal</span>
                        <ChevronDown className="w-3.5 h-3.5 text-slate-400" />
                      </div>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <Bold className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <Italic className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <Underline className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <Link className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <List className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <ListOrdered className="w-3.5 h-3.5" />
                      </button>
                      <button type="button" className="p-1 hover:bg-slate-200 rounded text-slate-700">
                        <Type className="w-3.5 h-3.5" />
                      </button>
                    </div>
                    <textarea
                      rows={5}
                      placeholder="พิมพ์รายละเอียดคำชี้แจงของแบบสอบถาม..."
                      value={formContent}
                      onChange={(e) => setFormContent(e.target.value)}
                      className="w-full p-3 text-xs bg-white focus:outline-none text-slate-800 resize-y"
                    />
                  </div>
                </div>
              </div>

              {/* Dynamic Questions */}
              <div className="space-y-4">
                {formQuestions.map((q, qIdx) => (
                  <div
                    key={q.id}
                    className="border border-slate-200 rounded-xl p-4 bg-white space-y-3 shadow-2xs"
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-bold text-slate-800 flex items-center gap-1.5">
                        <HelpCircle className="w-4 h-4 text-blue-600" />
                        คำถามที่ {qIdx + 1}
                      </span>
                      {formQuestions.length > 1 && (
                        <button
                          type="button"
                          onClick={() =>
                            setFormQuestions((prev) => prev.filter((_, idx) => idx !== qIdx))
                          }
                          className="text-rose-500 hover:text-rose-700 text-xs flex items-center gap-1 cursor-pointer"
                        >
                          <Trash2 className="w-3.5 h-3.5" /> ลบคำถาม
                        </button>
                      )}
                    </div>

                    <input
                      type="text"
                      placeholder="ระบุข้อคำถาม เช่น ทดสอบ"
                      value={q.title}
                      onChange={(e) =>
                        setFormQuestions((prev) =>
                          prev.map((item, idx) => (idx === qIdx ? { ...item, title: e.target.value } : item))
                        )
                      }
                      className="w-full p-2 text-xs bg-slate-50 border border-slate-200 rounded-lg text-slate-800"
                    />

                    <div className="space-y-2 pt-1">
                      <span className="text-[11px] font-semibold text-slate-600 block">
                        ตัวเลือกคำตอบ (Choices):
                      </span>
                      {q.options.map((opt, oIdx) => (
                        <div key={opt.id} className="flex items-center gap-2">
                          <span className="w-5 h-5 rounded-full bg-slate-100 flex items-center justify-center text-[10px] font-bold text-slate-600 shrink-0">
                            {oIdx + 1}
                          </span>
                          <input
                            type="text"
                            value={opt.text}
                            onChange={(e) =>
                              setFormQuestions((prev) =>
                                prev.map((item, idx) =>
                                  idx === qIdx
                                    ? {
                                        ...item,
                                        options: item.options.map((o, oi) =>
                                          oi === oIdx ? { ...o, text: e.target.value } : o
                                        ),
                                      }
                                    : item
                                )
                              )
                            }
                            placeholder={`ตัวเลือกที่ ${oIdx + 1}`}
                            className="flex-1 p-2 text-xs bg-white border border-slate-200 rounded-lg text-slate-800"
                          />
                          {q.options.length > 2 && (
                            <button
                              type="button"
                              onClick={() =>
                                setFormQuestions((prev) =>
                                  prev.map((item, idx) =>
                                    idx === qIdx
                                      ? {
                                          ...item,
                                          options: item.options.filter((_, oi) => oi !== oIdx),
                                        }
                                      : item
                                  )
                                )
                              }
                              className="p-1.5 text-slate-400 hover:text-rose-600 rounded"
                            >
                              <X className="w-3.5 h-3.5" />
                            </button>
                          )}
                        </div>
                      ))}

                      <button
                        type="button"
                        onClick={() =>
                          setFormQuestions((prev) =>
                            prev.map((item, idx) =>
                              idx === qIdx
                                ? {
                                    ...item,
                                    options: [
                                      ...item.options,
                                      {
                                        id: `opt-${Date.now()}`,
                                        text: `ตัวเลือก ${item.options.length + 1}`,
                                        votes: 0,
                                      },
                                    ],
                                  }
                                : item
                            )
                          )
                        }
                        className="text-xs text-blue-600 hover:underline font-semibold flex items-center gap-1 pt-1 cursor-pointer"
                      >
                        <Plus className="w-3.5 h-3.5" /> เพิ่มตัวเลือกคำตอบ
                      </button>
                    </div>
                  </div>
                ))}

                <button
                  type="button"
                  onClick={() =>
                    setFormQuestions((prev) => [
                      ...prev,
                      {
                        id: `q-${Date.now()}`,
                        title: 'คำถามข้อใหม่',
                        type: 'single',
                        options: [
                          { id: `opt-1`, text: 'ตัวเลือก 1', votes: 0 },
                          { id: `opt-2`, text: 'ตัวเลือก 2', votes: 0 },
                        ],
                      },
                    ])
                  }
                  className="px-4 py-2 rounded-xl border border-dashed border-blue-400 bg-blue-50/40 hover:bg-blue-50 text-blue-600 text-xs font-bold flex items-center gap-1.5 cursor-pointer transition-colors"
                >
                  <Plus className="w-4 h-4" /> เพิ่มคำถาม
                </button>
              </div>
            </div>

            {/* Right Column: Live Mobile Mockup Preview */}
            <div className="lg:col-span-5 flex flex-col items-center space-y-3">
              <h3 className="text-xs font-bold text-slate-700">ตัวอย่างการแสดงผล</h3>

              <div className="w-[280px] sm:w-[300px] h-[520px] bg-slate-950 rounded-[40px] p-3 shadow-2xl border-4 border-slate-800 relative flex flex-col">
                <div className="w-24 h-4 bg-slate-900 rounded-full mx-auto mb-2 shrink-0 flex items-center justify-center">
                  <div className="w-8 h-1 bg-slate-700 rounded-full" />
                </div>

                <div className="w-full h-full bg-white rounded-[28px] overflow-hidden flex flex-col relative text-slate-900 shadow-inner">
                  <div className="bg-slate-900 text-white px-4 py-2.5 text-[11px] font-bold flex items-center justify-between shrink-0">
                    <span>นราวดี อิลิแกนซ์</span>
                    <span className="text-[9px] text-blue-400">9:41 AM</span>
                  </div>

                  <div className="flex-1 overflow-y-auto p-4 space-y-3">
                    <h4 className="font-bold text-xs leading-snug text-slate-900 break-words">
                      {formTitle || 'QA tester'}
                    </h4>

                    <div className="flex items-center gap-1 text-[9px] text-slate-500">
                      <Calendar className="w-3 h-3 text-amber-500" />
                      <span>ปิดโหวต: {formEndDate || '31/03/2024'}</span>
                    </div>

                    {formCoverImage && (
                      <img
                        src={formCoverImage}
                        alt="Survey Cover"
                        className="w-full h-28 object-cover rounded-xl shadow-xs"
                        referrerPolicy="no-referrer"
                      />
                    )}

                    {formContent && (
                      <p className="text-[11px] text-slate-600 leading-relaxed break-words whitespace-pre-line">
                        {formContent}
                      </p>
                    )}

                    {formQuestions.map((q, qIdx) => (
                      <div key={q.id} className="p-3 bg-slate-50 rounded-xl border border-slate-200 space-y-2">
                        <div className="text-[10px] font-bold text-slate-800">
                          {qIdx + 1}. {q.title || 'คำถาม'}
                        </div>
                        <div className="space-y-1.5">
                          {q.options.map((opt) => (
                            <label
                              key={opt.id}
                              className="flex items-center gap-2 p-1.5 rounded-lg bg-white border border-slate-200 text-[10px] text-slate-700 cursor-pointer"
                            >
                              <input
                                type="radio"
                                name={`mock-q-${q.id}`}
                                className="w-3 h-3 text-blue-600"
                                defaultChecked={false}
                              />
                              <span>{opt.text || 'ตัวเลือก'}</span>
                            </label>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="w-20 h-1 bg-slate-300 rounded-full mx-auto my-1.5 shrink-0" />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ========================================================================= */}
      {/* 4. SURVEY MAIN LIST SCREEN (Exact match to Image 1) */}
      {/* ========================================================================= */}
      {viewMode === 'list' && (
        <div className="p-5 sm:p-6 space-y-5">
          {/* Header Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <button
                type="button"
                onClick={onBackToMenu}
                className="w-8 h-8 rounded-full border border-slate-300 hover:bg-slate-100 flex items-center justify-center text-slate-600 transition-colors cursor-pointer"
                title="กลับสู่เมนูงานเจ้าของร่วม/สมาชิก"
              >
                <ChevronLeft className="w-5 h-5" />
              </button>
              <h1 className="text-xl font-bold text-slate-900">แบบสอบถาม</h1>
            </div>

            <button
              type="button"
              onClick={handleOpenCreate}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold flex items-center gap-1.5 shadow-xs transition-colors cursor-pointer"
            >
              <Plus className="w-4 h-4" /> เพิ่มแบบสอบถาม
            </button>
          </div>

          {/* Action & Filter Bar */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 pt-1">
            <div className="relative w-full sm:w-auto">
              <button
                type="button"
                onClick={() => setBatchMenuOpen(!batchMenuOpen)}
                className="px-3.5 py-2 rounded-lg border border-slate-300 bg-white hover:bg-slate-50 text-xs font-medium text-slate-700 flex items-center justify-between gap-2 w-full sm:w-auto cursor-pointer shadow-2xs"
              >
                <span>จัดการหลายรายการ</span>
                <ChevronDown className="w-3.5 h-3.5 text-slate-500" />
              </button>

              {batchMenuOpen && (
                <div className="absolute left-0 mt-1 w-48 bg-white border border-slate-200 rounded-xl shadow-lg p-1.5 z-20 space-y-1 text-xs">
                  <button
                    type="button"
                    onClick={handleBatchDelete}
                    disabled={selectedIds.length === 0}
                    className={`w-full text-left px-3 py-1.5 rounded-lg font-medium flex items-center gap-2 ${
                      selectedIds.length > 0
                        ? 'text-rose-600 hover:bg-rose-50 cursor-pointer'
                        : 'text-slate-300 cursor-not-allowed'
                    }`}
                  >
                    <Trash2 className="w-3.5 h-3.5" /> ลบรายการที่เลือก ({selectedIds.length})
                  </button>
                </div>
              )}
            </div>

            <div className="flex items-center gap-2 w-full sm:w-auto justify-end text-xs">
              <div className="relative flex-1 sm:w-64">
                <Search className="w-3.5 h-3.5 absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
                <input
                  type="text"
                  placeholder="ค้นหา"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full pl-8 pr-2.5 py-1.5 border border-slate-300 rounded-lg text-xs bg-white text-slate-700 focus:outline-none"
                />
              </div>

              <button
                type="button"
                onClick={() => {}}
                className="px-4 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-xs font-bold transition-colors cursor-pointer"
              >
                ค้นหา
              </button>
            </div>
          </div>

          {/* Table matching Image 1 */}
          <div className="border border-slate-200 rounded-xl overflow-hidden shadow-2xs">
            <table className="w-full text-left text-xs">
              <thead className="bg-slate-100/80 text-slate-600 font-semibold border-b border-slate-200">
                <tr>
                  <th className="p-3 w-10 text-center">
                    <input
                      type="checkbox"
                      onChange={(e) => {
                        if (e.target.checked) {
                          setSelectedIds(filteredSurveys.map((i) => i.id));
                        } else {
                          setSelectedIds([]);
                        }
                      }}
                      checked={
                        filteredSurveys.length > 0 && selectedIds.length === filteredSurveys.length
                      }
                      className="rounded text-blue-600 focus:ring-blue-500"
                    />
                  </th>
                  <th className="p-3">เรื่อง/คำอธิบาย</th>
                  <th className="p-3">โพสต์โดย</th>
                  <th className="p-3">วันที่ปิดโหวต</th>
                  <th className="p-3">
                    <div className="flex items-center gap-1 cursor-pointer">
                      <span>วันที่โพสต์</span>
                      <ChevronDown className="w-3 h-3 text-slate-400" />
                    </div>
                  </th>
                  <th className="p-3">ผู้ลงคะแนน</th>
                  <th className="p-3 text-right"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 bg-white">
                {filteredSurveys.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="py-12 text-center text-slate-400">
                      ไม่พบข้อมูลแบบสอบถาม
                    </td>
                  </tr>
                ) : (
                  filteredSurveys.map((item) => {
                    const isSelected = selectedIds.includes(item.id);
                    return (
                      <tr
                        key={item.id}
                        className={`hover:bg-slate-50/80 transition-colors ${
                          isSelected ? 'bg-blue-50/30' : ''
                        }`}
                      >
                        <td className="p-3 text-center">
                          <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => {
                              setSelectedIds((prev) =>
                                prev.includes(item.id)
                                  ? prev.filter((id) => id !== item.id)
                                  : [...prev, item.id]
                              );
                            }}
                            className="rounded text-blue-600 focus:ring-blue-500"
                          />
                        </td>

                        {/* Title Link: Opens Survey Detail View (Image 1 -> Image 2) */}
                        <td className="p-3">
                          <div className="flex items-center gap-2">
                            <span
                              onClick={() => handleOpenSurveyDetail(item)}
                              className="font-bold text-sky-600 hover:text-sky-700 hover:underline cursor-pointer"
                            >
                              {item.title}
                            </span>
                            {item.isDraft && (
                              <span className="text-[10px] text-rose-500 font-medium">
                                แบบร่าง
                              </span>
                            )}
                          </div>
                          <div className="text-[11px] text-slate-400 mt-0.5">{item.description}</div>
                        </td>

                        <td className="p-3 text-slate-600 font-medium">{item.author}</td>

                        <td className="p-3 text-slate-600 font-mono">{item.closeDate}</td>

                        <td className="p-3 text-slate-600 font-mono">{item.postedAt}</td>

                        <td className="p-3 text-slate-700 font-mono font-medium">
                          {item.votedCount}/{item.totalEligible}
                        </td>

                        <td className="p-3 text-right">
                          <div className="flex items-center justify-end gap-2 text-slate-400">
                            <button
                              type="button"
                              onClick={(e) => handleOpenEdit(item, e)}
                              title="แก้ไข"
                              className="p-1 hover:text-blue-600 transition-colors cursor-pointer"
                            >
                              <Edit2 className="w-3.5 h-3.5" />
                            </button>
                            <button
                              type="button"
                              onClick={(e) => handleDeleteItem(item.id, e)}
                              title="ลบ"
                              className="p-1 hover:text-rose-600 transition-colors cursor-pointer"
                            >
                              <Trash2 className="w-3.5 h-3.5" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="flex items-center justify-between text-xs text-slate-500 pt-2">
            <span>รายการทั้งหมด {filteredSurveys.length}</span>
          </div>
        </div>
      )}
    </div>
  );
};
